var thTH = {
	"codeBlock.copied": "คัดลอกแล้ว",
	"codeBlock.copyLabel": "คัดลอก",
	"inlineCodeBlock.copied": "คัดลอกแล้ว",
	"inlineCodeBlock.copyLabel": "คัดลอกรหัสอินไลน์"
};

export { thTH as default };
